<div [formGroup]="group" *ngIf="config.numberFormat !== 'phoneNumber' && !config.inputControls && !config.isPhoneNumber && !decimalNumbersOnly " [hidden]="config.hide"
  class="form-input {{config.class}}">
  <span *ngIf="config.formInputIcon" class="rs-me-5">
    <i class="{{config.formInputIcon}} seat-icon-color"></i>
  </span>
  <div *ngIf="!config.appearanceOutline && !config.icon && config.label" for="" class="default-sub-header text-label">{{config.label | translate}} <span *ngIf="config.isMandatory" class="mandatory-field">*</span></div>
  <mat-form-field class="basic-input-field " [ngClass]="{'input-with-boundary':config.appearance}"  [appearance]="config.appearanceOutline ? 'outline': 'none'">
  
     <mat-label *ngIf="!config.appearanceOutline && config.icon && config.label" class="select-label">
      <i class="view-icon {{config.icon}}"></i>
      <span>{{config.label | translate}}</span> 
    </mat-label> 
    <mat-label *ngIf="!config.icon && config.label && config.appearanceOutline">{{config.label | translate}}</mat-label>
    <input matInput placeholder="{{config.placeholder | translate}}" [type]="config.inputType? config.inputType:'text'"
      [formControlName]="config.name" [attr.name]="config.name" [errorStateMatcher]="config.appearanceOutline ? false : matcher"
      [attr.autocomplete]="config.autocomplete != undefined ? config.autocomplete : 'off'"
      [ngClass]="{'adjusted-width':config.icon1}" *ngIf="config.inputType !== 'number'" (keyup)="onKeyup($event)" >
      <input matInput placeholder="{{config.placeholder | translate}}" [type]="config.inputType? config.inputType:'text'"
      [formControlName]="config.name" [attr.name]="config.name" [errorStateMatcher]="config.appearanceOutline ? false : matcher"
      [attr.autocomplete]="config.autocomplete != undefined ? config.autocomplete : 'off'"
      [ngClass]="{'adjusted-width':config.icon1}" *ngIf="config.inputType == 'number'" [min]="0">
    <i class="view-icon {{config.icon1}} seat-icon-color"
      *ngIf="config.icon1 && group.controls[FormControlName].value && !config.showIconAlways"
      (click)="iconClick($event)"></i>
    <i class="view-icon {{config.icon1}} seat-icon-color" *ngIf="config.icon1 && config.showIconAlways"
      (click)="iconClick($event)"></i>
      <mat-error
      *ngIf=" !group.controls[FormControlName].hasError('email') && group.controls[FormControlName].hasError('pattern')">
      {{'invalidText' | translate}}
    </mat-error>
    <mat-error
      *ngIf="!group.controls[FormControlName].hasError('pattern') && group.controls[FormControlName].hasError('required') && config.showErrorText &&  group.controls[FormControlName].dirty">
      {{config.errorMessage | translate}}
    </mat-error>
    <mat-error
      *ngIf="(group.controls[FormControlName].value && (group.controls[FormControlName].hasError('email')) && group.controls[FormControlName].dirty && config.showErrorText)">
      {{'invalidEmail' | translate}}
    </mat-error>
    <mat-error
    *ngIf="!group.controls[FormControlName].hasError('pattern') && group.controls[FormControlName].value && group.controls[FormControlName].hasError('max')">
      {{'errorPaidAmount' | translate}}
    </mat-error>
    <mat-error
      *ngIf="group.controls[FormControlName].hasError('minlength') && group.controls[FormControlName].touched && config.showErrorText">
      {{'minlengthValidationMessage' | translate: {charLength: config.charLength} }}
    </mat-error>
  </mat-form-field>
</div>

  <div [formGroup]="group" class="form-input {{config.class}}" *ngIf="config.numberFormat !== 'phoneNumber' && inputControls && !config.isPhoneNumber && !decimalNumbersOnly">
   <div for="" class="default-form-field text-label">{{config.label | translate}} <span *ngIf="config.isMandatory" class="mandatory-field">*</span></div>
  <span class="controls-icon" [ngClass]="{'disabled-icon':config.decreaseDisabled}" (click)="decreaseClicked($event)">-</span>
  <mat-form-field class="basic-input-field " [ngClass]="{'input-with-boundary':config.appearance}">

    <input matInput readonly placeholder="{{config.placeholder | translate}}"
      [type]="config.inputType? config.inputType:'text'" [formControlName]="config.name" [attr.name]="config.name"
      [errorStateMatcher]="matcher" [attr.autocomplete]="config.autocomplete != undefined ? config.autocomplete : 'off'"
      [ngClass]="{'adjusted-width':config.icon1}" (keyup)="onKeyup($event)" >
      <mat-error class="mt-4"
      *ngIf="group.controls[FormControlName].hasError('pattern')">
      {{'invalidText' | translate}}
    </mat-error>

  </mat-form-field>
  <span class="controls-icon" [ngClass]="{'disabled-icon':config.increaseDisabled}"
    (click)="increaseClicked($event)">+</span>
</div>
<div [formGroup]="group" class="form-input {{config.class}}" *ngIf=" config.numberFormat !== 'phoneNumber' && decimalNumbersOnly">
  <mat-form-field class="basic-input-field" [ngClass]="config.class">
    <mat-label class="select-label">{{config.label | translate}}</mat-label>
    <span matPrefix *ngIf="prefix">{{prefix}} &nbsp;</span>
    <input matInput placeholder="{{config.placeholder | translate}}" [type]="config.inputType? config.inputType:'text'"
      [formControlName]="config.name" (keyup)="onKeyup($event)" [attr.name]="config.name"
      [maxlength]="config.charLength" [errorStateMatcher]="matcher"
      [attr.autocomplete]="config.autocomplete != undefined ? config.autocomplete : 'off'" appDecimalsOnly>
      <mat-error class="mt-4"
      *ngIf="group.controls[FormControlName].hasError('pattern')">
      {{'invalidText' | translate}}
    </mat-error>
    <mat-error *ngIf="group.controls[FormControlName].hasError('required') && config.showErrorText">
      {{config.errorMessage | translate}}
    </mat-error>
    <mat-error
      *ngIf="group.controls[FormControlName].hasError('minlength') && group.controls[FormControlName].touched && config.showErrorText">
      Please enter a minimum of {{config.charLength}} characters.
    </mat-error>
    <mat-error
      *ngIf="FormControlName == 'customSize' && group.controls[FormControlName].invalid && config.showErrorText">
      {{config.errorMessage | translate}}
    </mat-error>
    <mat-error
    *ngIf="FormControlName == 'refundAmountConfig' && group.controls[FormControlName].value && group.controls[FormControlName].hasError('max')">
  {{'refundError' | translate}}
  </mat-error>
  </mat-form-field>
</div>

<div [formGroup]="group" *ngIf="config.numberFormat == 'phoneNumber' && !config.inputControls && !config.isPhoneNumber && !decimalNumbersOnly " [hidden]="config.hide"
  class="form-input {{config.class}}">
  <span *ngIf="config.formInputIcon" class="rs-me-5">
    <i class="{{config.formInputIcon}} seat-icon-color"></i>
  </span>
  <div *ngIf="!config.appearanceOutline && !config.icon && config.label" for="" class="default-sub-header text-label">{{config.label | translate}} <span *ngIf="config.isMandatory" class="mandatory-field">*</span></div>
  <mat-form-field class="basic-input-field " [ngClass]="{'input-with-boundary':config.appearance}"  [appearance]="config.appearanceOutline ? 'outline': 'none'">
  
     <mat-label *ngIf="!config.appearanceOutline && config.icon && config.label" class="select-label">
      <i class="view-icon {{config.icon}}"></i>
      <span>{{config.label | translate}}</span> 
    </mat-label> 
    <mat-label *ngIf="!config.icon && config.label && config.appearanceOutline">{{config.label | translate}}</mat-label>
    <input matInput  [maxlength]="dfs.requiredPhoneNumberLength$" placeholder="{{config.placeholder | translate}}" [type]="config.inputType? config.inputType:'text'"
      [formControlName]="config.name" [attr.name]="config.name" [errorStateMatcher]="config.appearanceOutline ? false : matcher"
      [attr.autocomplete]="config.autocomplete != undefined ? config.autocomplete : 'off'"
      [ngClass]="{'adjusted-width':config.icon1}" *ngIf="config.inputType !== 'number'" (keyup)="onKeyup($event)" phoneNumber>
      <input matInput [maxlength]="dfs.requiredPhoneNumberLength$" placeholder="{{config.placeholder | translate}}" [type]="config.inputType? config.inputType:'text'"
      [formControlName]="config.name" [attr.name]="config.name" [errorStateMatcher]="config.appearanceOutline ? false : matcher"
      [attr.autocomplete]="config.autocomplete != undefined ? config.autocomplete : 'off'"
      [ngClass]="{'adjusted-width':config.icon1}" *ngIf="config.inputType == 'number'" [min]="0" phoneNumber>
    <i class="view-icon {{config.icon1}} seat-icon-color"
      *ngIf="config.icon1 && group.controls[FormControlName].value && !config.showIconAlways"
      (click)="iconClick($event)"></i>
    <i class="view-icon {{config.icon1}} seat-icon-color" *ngIf="config.icon1 && config.showIconAlways"
      (click)="iconClick($event)"></i>
      <mat-error
      *ngIf=" !group.controls[FormControlName].hasError('email') && group.controls[FormControlName].hasError('pattern')">
      {{'invalidText' | translate}}
    </mat-error>
    <mat-error
      *ngIf="!group.controls[FormControlName].hasError('pattern') && group.controls[FormControlName].hasError('required') && config.showErrorText &&  group.controls[FormControlName].dirty">
      {{config.errorMessage | translate}}
    </mat-error>
    <mat-error
      *ngIf="(group.controls[FormControlName].value && (group.controls[FormControlName].hasError('email')) && group.controls[FormControlName].dirty && config.showErrorText)">
      {{'invalidEmail' | translate}}
    </mat-error>
    <mat-error
    *ngIf="!group.controls[FormControlName].hasError('pattern') && group.controls[FormControlName].value && group.controls[FormControlName].hasError('max')">
      {{'errorPaidAmount' | translate}}
    </mat-error>
  </mat-form-field>
</div>